module.exports = __webpack_public_path__ + "static/media/ragismeni-vera-bg.939a30a8.jpg";